<span *ngIf="username; else chooser" (click)="showUsers()" class="badge badge-success">{{
    username
}}</span>
<ng-template #chooser>
    <span class="badge badge-warning" (click)="showUsers()">Assign</span>
</ng-template>
